export const text = {
  title: "Change Password",
  oldPasswordLabel: "Old Password",
  newPasswordLabel: "New Password",
  newPasswordPlaceHolder: "New Password",
  confirmNewPasswordLabel: "Confirm New Password",
  oldPasswordPlaceHolder: "Enter Old Password",
  confirmPasswordPlaceHolder: "Enter Confirm New Password",
};
